import styled from 'styled-components'

const CustomAffix = styled.div`
  position: fixed;
  top: 0%;
  z-index: 50;
`

export default CustomAffix
